import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_USER, IS_DEMO } from "../../config";
import axios from "axios";
import GetApiwithoutPayload from "services";

const initialState = {
  Roledropdown: {},
  notification: {},
};

const RoleDataSilce = createSlice({
  name: "RoleDropdown",
  initialState,
  reducers: {
    setRoledropdown(state, action) {
      state.Roledropdown = action.payload;
    },
    setToast(state, action) {
      state.notification = action.payload;
    },
  },
});

export const { setRoledropdown, setToast } = RoleDataSilce.actions;

export const RoleDataDropdown = (accessToken) => async (dispatch) => {
  const data = await GetApiwithoutPayload(
    `${process.env.REACT_APP_BASE_URL}/role/dropdown`,
    accessToken
  )
    .then((res) => {
      console.log(res, "API Responsesvdfvcsdghcvsgdacsd");
      const parsedData = res as any;
      console.log(parsedData, "API Response");
      dispatch(setRoledropdown(parsedData));
    })
    .catch((err) => {
      console.log(err.response);
    });
};

const RoleDropdownReducer = RoleDataSilce.reducer;

export default RoleDropdownReducer;
